import React from 'react'
import MarkAttendance from '../../components/student/attendance/MarkAttendance'
import AttendanceList from '../../components/student/attendance/AttendanceList'

export default function Attendance() {
  return (
    <div>
      <MarkAttendance/>
      <AttendanceList/>
    </div>
  )
}
